import { render, staticRenderFns } from "./add-exercises-modal.vue?vue&type=template&id=9b28406a&"
import script from "./add-exercises-modal.vue?vue&type=script&lang=js&"
export * from "./add-exercises-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports